import { Form, Head } from "@inertiajs/react"

import Heading from "@/components/heading"
import InputError from "@/components/input-error"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Spinner } from "@/components/ui/spinner"
import AppLayout from "@/layouts/app-layout"
import { inviteUsersPath, usersPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Users",
    href: usersPath(),
  },
  {
    title: "Invite user",
    href: inviteUsersPath(),
  },
]

export default function InviteUser() {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Invite user" />

      <div className="space-y-6 p-4 lg:p-8">
        <Heading
          title="Invite user"
          description="Send an invitation to a new user"
        />

        <Form
          method="post"
          action={inviteUsersPath()}
          className="max-w-md space-y-6"
        >
          {({ processing, errors }) => (
            <>
              <div className="grid gap-2">
                <Label htmlFor="name">Name</Label>
                <Input
                  id="name"
                  type="text"
                  name="name"
                  required
                  autoFocus
                  autoComplete="name"
                  placeholder="Full name"
                />
                <InputError messages={errors.name} />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="email">Email address</Label>
                <Input
                  id="email"
                  type="email"
                  name="email"
                  required
                  autoComplete="email"
                  placeholder="email@example.com"
                />
                <InputError messages={errors.email} />
              </div>

              <div className="flex items-center gap-2">
                <input
                  id="admin"
                  type="checkbox"
                  name="admin"
                  value="1"
                  className="h-4 w-4 rounded border-gray-300"
                />
                <Label htmlFor="admin">Admin</Label>
              </div>

              <Button type="submit" disabled={processing}>
                {processing && <Spinner />}
                Send invitation
              </Button>
            </>
          )}
        </Form>
      </div>
    </AppLayout>
  )
}
